import { atom } from "jotai";

export interface IInventoryMovement {
    id?: number;
    inventory_item_id: number;
    from_zone_id?: number | null;
    to_zone_id?: number | null;
    delta_units?: number;
    reason?: string;
    actor?: number | null;
    created_at?: string;
    updated_at?: string;
}

export interface IInventoryMovementInput extends Omit<IInventoryMovement, 'id' | 'created_at' | 'updated_at'> {}

export const inventoryMovementsAtom = atom<IInventoryMovement[]>([]);
export const inventoryMovementsLoadingAtom = atom<boolean>(false);

